<template>
  <pie-chart
    v-if="chartData"
    key="gradeChart"
    :chart-data="chartData"
    :tooltips-callback-cfg="tooltipsCallbackCfg"
    :legendCfg="{
      position: 'right'
    }"
  ></pie-chart>
</template>
<script>
import PieChart from "@/components/Base/PieChart";
import { COLOR_OPTION_CLASSES } from "@/helpers/color-chart-config";
export default {
  name: "classes-chart-teacher",
  components: { PieChart },
  props: ["classesData"],
  data() {
    return {
      tooltipsCallbackCfg: {
        title: {
          prefix: "Grade"
        },
        label: true,
        afterLabel: {
          subfix: "classes"
        }
      }
    };
  },
  computed: {
    chartData() {
      return this.generateClassesChart(this.classesData);
    }
  },
  methods: {
    generateClassesChart(classesData) {
      if (!classesData) return null;

      const { labels, data } = classesData;
      return {
        labels,
        datasets: [
          {
            data,
            backgroundColor: labels.map(label => COLOR_OPTION_CLASSES[label]),
            borderWidth: 1
          }
        ]
      };
    }
  }
};
</script>
